import React from "react";
import { useNavigate } from "react-router-dom"; 
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToComponents = () => {
    navigate("/components");
  };

  const handleGoToHelp = () => {
    navigate("/help");
  };

  return (
    <main
      className="d-flex align-items-center"
      style={{
    minHeight: "calc(98vh - var(--header-h))",
    background: "linear-gradient(180deg, #f7f4fc 0%, #e9dcf5 50%, #d7bdf0 100%)",
    paddingTop: "0rem" // optional for breathing space
  }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-10 mx-auto text-center text-md-start">
            <h1 className="display-4 fw-bold mb-4 animate__animated animate__fadeInUp">
              Order <span className="text-primary">Machinery Parts</span> Online <br />
              with <span className="text-danger">Ease</span>
            </h1>
              {/* <p className="lead text-muted mb-4 animate__animated animate__fadeInUp animate__delay-1s">
                Access thousands of machinery parts from trusted suppliers worldwide.  
                Find exactly what you need, compare options, and order in just a few clicks.
              </p> */}
            <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-md-start animate__animated animate__fadeInUp animate__delay-2s">
              <button
                onClick={handleGoToComponents}
                className="btn btn-lg px-5 py-3 text-white shadow"
                style={{
                  background: "linear-gradient(90deg, #4776E6, #8E54E9)",
                  border: "none",
                }}
              >
                Go To Components
              </button>
              <button
                onClick={handleGoToHelp}
                className="btn btn-lg px-5 py-3 text-white shadow"
                style={{
                  background: "linear-gradient(90deg, #003366, #1f8ef1)",
                  border: "none",
                }}
              >
                Go To Help
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
